import { SerializedValueType } from "../../Model/Value/ValueInterface"
import BracketedValue from "../../Model/Value/BracketedValue"

import GameDeserializer from "../GameDeserializer"
import ValueDeserializerInterface from "./ValueDeserializerInterface"

export default class BracketedValueDeserializer implements ValueDeserializerInterface {
  private serializer: GameDeserializer | undefined
  public supports(payload: SerializedValueType): boolean {
    return payload.type === "bracketed"
  }

  public deserialize(payload: SerializedValueType): BracketedValue {
    if (this.serializer === undefined) {
      throw new Error("Unable to deserialize BracketedValueDeserializer")
    }

    return new BracketedValue(
      this.serializer.deserializeValue(payload.payload as SerializedValueType),
    )
  }

  public setSerializer(serializer: GameDeserializer): void {
    this.serializer = serializer
  }
}
